export default __webpack_public_path__ + "static/media/ipad_2026.76624a4b.png";